import { apiClient } from '@/shared/api';
import type { SystemPreset, SystemPresetCreate, SystemPresetListResponse, SystemPresetUpdate } from './types';

/**
 * Список системных пресетов по GET /system-preset.
 * Без имени таблицы сервер отдаёт пресеты всех таблиц.
 */
export const fetchSystemPresets = async (tableName?: string): Promise<SystemPresetListResponse> => {
  const { data } = await apiClient.get<SystemPresetListResponse>('/system-preset', {
    params: { 'table-name': tableName },
  });
  return data;
};

/** Создание системного пресета по POST /system-preset */
export const createSystemPreset = async (preset: SystemPresetCreate): Promise<SystemPreset> => {
  const { data } = await apiClient.post<SystemPreset>('/system-preset', preset);
  return data;
};

/** Обновление названия, вида или закрепления по PUT /system-preset/{id} */
export const updateSystemPreset = async ({ id, ...changes }: SystemPresetUpdate): Promise<SystemPreset> => {
  const { data } = await apiClient.put<SystemPreset>(`/system-preset/${id}`, changes);
  return data;
};

/** Удаление системного пресета по DELETE /system-preset/{id} */
export const deleteSystemPreset = async (id: number): Promise<void> => {
  await apiClient.delete(`/system-preset/${id}`);
};
